import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "~/components/content/content-item-render";
import type { cardContentItemContent$key } from "~/queries/__generated__/cardContentItemContent.graphql";

import { Container, Content, Header, StyledCoverEntityLink, StyledTitleEntityLink } from "./styles";

export type Props = {
  className?: string;
  provider: DefaultComponentsProvider;
  reference: cardContentItemContent$key;
};

export const ContentItemCard = forwardRef<HTMLDivElement, Props>(
  ({ className, provider, reference: reference_ }, reference) => {
    const entity = useFragment(
      graphql`
        fragment cardContentItemContent on Content {
          ...entityLink
        }
      `,
      reference_,
    );
    const header = (
      <StyledCoverEntityLink reference={entity}>
        {provider.coverImage({
          responsiveVariants: {
            desktopUp: "size540x360",
            mobileUp: "size540x360",
            tabletUp: "size540x360",
          },
        })}
      </StyledCoverEntityLink>
    );
    const content = (
      <StyledTitleEntityLink reference={entity}>
        {provider.headline({ hideTooltip: true })}
      </StyledTitleEntityLink>
    );
    const footer = provider.sponsorTag?.({
      color: "#001246",
      gap: "4px",
      imageVariant: "small",
      layoutDirection: "vertical",
      nameFontSize: "16px",
      typeFontSize: "12px",
    });

    return (
      <Container className={className} ref={reference}>
        <Header>{header}</Header>
        <Content>
          {content} {footer}
        </Content>
      </Container>
    );
  },
);

ContentItemCard.displayName = "ContentItemCard";
